import util from '../util'

let controller = 'MonitorADDA'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put', 'persist']), {
  ArquivosPendentes() {
    return util.Axios.GetAll(controller + '/Pendentes')
  },
  ObterBoletosPorADDA101: function (nomeArquivo) {
    let params = { nomeArquivo: nomeArquivo }
    return util.Axios.GetParams(controller + '/ADDA101/Boletos', params);
  },
  ObterBoletosPorADDA102(nomeArquivo) {
  let params = { nomeArquivo: nomeArquivo }
    return util.Axios.GetParams(controller + '/ADDA102/Boletos', params);
  },
  ObterBoletosPorADDA108(nomeArquivo) {
    let params = { nomeArquivo: nomeArquivo }
    return util.Axios.GetParams(controller + '/ADDA108/Boletos', params);
  }
})
